import { Col } from 'antd'
import { FC } from 'react'
import { PersonalProfileFragment } from '../../../types'
import { BonusHistoryTable } from '../contract/BonusHistoryTable'
import { SalaryHistoryTable } from '../contract/SalaryHistoryTable'
import { ContractComponent } from '../contract/ContractComponent'
import { BankAccountComponent } from '../contract/BankAccountComponent'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import { PaymentHistoryTable } from '../contract/PaymentHistoryTable'
import { NationalContractLevelHistoryTable } from '../contract/NationalContractLevelHistoryTable'
import { LevelHistoryTable } from '../contract/LevelHistoryTable'
import useCurrentContract from '../../../graphql/contract/hooks/useCurrentContract'
import { useAuth } from '../../../context/auth-context'
import { GovernmentJobTitleHistoryTable } from '../contract/GovernmentJobTitleHistoryTable'
import { NewLoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors/NewLoadingAndErrors'
import { useTranslation } from 'react-i18next'

interface PrivateContractTabProps {
  profile: PersonalProfileFragment
}

export const PrivateContractTab: FC<PrivateContractTabProps> = ({ profile }) => {
  const { data: contractData, error: contractError, loading: contractLoading } = useCurrentContract(profile.employeeId)
  const { user } = useAuth()
  const { t } = useTranslation()
  if (contractLoading || contractError || !contractData || !contractData.currentContract) {
    return (
      <NewLoadingAndErrors
        isLoading={contractLoading}
        error={contractError}
        hasNoData={!contractData || !contractData.currentContract}
        showSpinner
        t={t}
      />
    )
  }
  const timezone = {
    locale: user.locale,
    timezone: contractData.branchOfficeByEmployee.timezone,
  }
  const currentContract = contractData.currentContract

  return (
    <>
      <PerFlexRow>
        <Col span={12}>
          <ContractComponent
            currentContract={currentContract}
            businessUnit={profile.businessUnit ? profile.businessUnit : undefined}
            timezone={timezone}
            branchOfficeCode={profile.branchOfficeCode}
          />
        </Col>
        {profile.bankAccount && (
          <Col span={12}>
            <BankAccountComponent bankAccount={profile.bankAccount} />
          </Col>
        )}
      </PerFlexRow>

      <SalaryHistoryTable
        employeeId={profile.employeeId}
        isMonthlySalaryDisplayed={currentContract.isMonthlySalaryDisplayed}
        monthlySalaryMonthsInYear={currentContract.monthlySalaryMonthsInYear}
        timezone={timezone}
      />

      <BonusHistoryTable employeeId={profile.employeeId} timezone={timezone} />

      <GovernmentJobTitleHistoryTable employeeId={profile.employeeId} timezone={timezone} />

      <NationalContractLevelHistoryTable employeeId={profile.employeeId} timezone={timezone} />

      <LevelHistoryTable employeeId={profile.employeeId} timezone={timezone} />

      <PaymentHistoryTable employeeId={profile.employeeId} timezone={timezone} />
    </>
  )
}
